// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3L1DP","savePackageButton":"ClientWallet_savePackageButton__9VGOH"};